import template from '../../../../../../ui-formly/partials/form.html'
import FormControllerFactory from '../../../../../../ui-formly/controllers/FormControllerFactory'
import fields from './formly'
import { vsName as commonMachineServerName } from '../../../../Server/index'

export const vsName = 'machinePerformanceGuaranteeEdit'
export const vsNgType = 'directive'

machinePerformanceGuaranteeEditDirective.$inject = [commonMachineServerName]
export function machinePerformanceGuaranteeEditDirective(commonMachineServer) {
  return {
    templateUrl: template,
    transclude: false,
    restrict: 'E',
    scope: {
      model: '='
    },
    controller: FormControllerFactory({
      returnState: '^',
      formFields: fields(),
      submit: commonMachineServer.performanceGuaranteeSave
    }),
    controllerAs: 'ctrl',
    bindToController: true
  }
}
